import { TFunction } from 'next-i18next';
import { routes } from '@/infrastructure/const/routes';
import { IMenuLink } from '@/infrastructure/interfaces/i-link';
import { isPublicBlogEnabled } from '@/infrastructure/const/features';
import {
  ImportContactsRounded,
  BookmarksRounded,
  HomeRounded,
  GroupsRounded,
  ArticleRounded,
} from '@mui/icons-material';

export const menuLinks = (t: TFunction): IMenuLink[] => {
  return [
    {
      path: routes.home,
      title: t('home'),
      icon: HomeRounded,
    },
    {
      path: routes.reciters,
      title: t('allReciters'),
      icon: GroupsRounded,
    },
    {
      path: routes.surahRead,
      title: t('surahs'),
      icon: ImportContactsRounded,
    },
    ...(isPublicBlogEnabled()
      ? [
          {
            path: routes.blog,
            title: t('blog'),
            icon: ArticleRounded,
          },
        ]
      : []),
    {
      path: routes.bookmarks,
      title: t('bookmarks'),
      icon: BookmarksRounded,
      authorized: true,
    },
  ];
};
